/**
 * Curated spiritual survey questions for the Listen / Connect flow.
 * Used for reference and for bulk-import into the survey question pool.
 * One question per line (trimmed). Empty lines are skipped.
 */
export const SURVEY_QUESTIONS_SEED = [
  'What three words would you use to describe your life?',
  'What single thing do you want to make absolutely sure you do during your life if possible?',
  'What happens after death?',
  'Your best friend comes to you and says, "I want to become a Christian, but I don\'t know how." What would you tell your friend?',
  'On a scale from 1 to 10, rate your desire to know God.',
  'What personal challenges have deepened your spiritual growth?',
  'What spiritual mentors or influences have been important to you?',
  'What spiritual doubts have you experienced?',
  'How have your beliefs evolved over time?',
  'What is your spiritual background? (This is a great opening question; you may be surprised at what you learn!)',
  'When you think of God, what picture comes to mind?',
  'What are a few significant spiritual moments (or milestones) in your life? (This question may give you valuable information about their spiritual journey.)',
  'How would you describe where you are spiritually right now?',
  'What are some of your most pressing spiritual questions?',
  'Who do you think Jesus was, and why?',
  'Who is your spiritual hero-role model?',
  'Is there anything in the Bible that you don\'t like?',
  'In terms of religion, who has had the biggest influence on your life?',
  'What is your earliest experience of God?',
  'Are there any features of the world that give you pause and make you think there might be a God?',
  'Was there ever a time you believed in God? If so, why did you think it changed?',
  'How important is spirituality to your life now? Has this changed over time? If so, why?',
  'Are there any things that attract you to religion in general or Christianity in particular? And are there any things that turn you away?',
  'What experiences have most shaped your spiritual life?',
  'What might convince you to believe in God?',
  'Who is the first person who created a memory of God for you?',
  'Why is it that we always want more, no matter how much we have?',
  'What is the reason for our existence?',
  'Where is the source of the strife and turmoil that characterizes humanity throughout our history?',
  'What would it take to persuade you that the Bible really is true?',
  'Do you want Christianity to be true?',
  'Where do you find peace and replenishment when the world goes crazy?',
  'What happens to us when we die?',
  'How would you describe where you\'re at on your journey through life?',
  'Why are religious discussions so polarizing at times?',
  'Who is the spiritual leader you most admire?',
  'What is your opinion about why religious faith is (or is not) important?',
  'How do people get into heaven after they leave this life?',
  'Is it possible to live a life of great joy in spite of our circumstances?',
  'Who is Jesus Christ in your opinion?',
  'How has your view of God changed since you were a child?',
  'What will have to happen for the whole world to finally live in peace?',
  'What do you think happens when we pray?',
  'If there were life after death would you want to know about it?',
  'If God doesn\'t exist, where did our ideas about him come from?',
  'How can I pray for you today?',
  'What is your dream job?',
  'Are you working toward it already? If not, what is standing in your way?',
  'What advice would you give to a young person about finding vocational happiness?',
  'What kind of exposure did you have to religion when you were growing up?',
  'Why do you think there are so many different religions?',
  'Do you think it\'s possible for all religions to be equally right? Why or why not?',
  'What conclusions have you come to concerning life after death?',
  'Do you think it\'s possible to be certain about where you\'ll spend eternity?',
  'Have you ever explored what the Bible has to say about eternal life?',
  'Have you ever been able to get a handle on what you think your purpose in life is?',
  'Everyone seems to agree that money by itself can\'t buy happiness. What, in your opinion, does money guarantee a happy life?',
  'In what ways do you feel you\'re really winning or losing at life?',
  'Do you consider yourself to be a Christian?',
  'Based on your understanding, how does someone become a Christian?',
  'Have you ever explored what the Bible has to say about how someone becomes a Christian?',
  'Have you ever had an experience in which you felt the presence of evil?',
  'Have you ever had an experience in which you felt the presence of God?',
  'In what ways have you seen good and evil played out in your life?',
  'It sounds as if you value open-mindedness. Do you ever find yourself closing your mind to certain things, ideas, or people?',
  'What criteria do you use to determine whether something is true?',
  'Does your worldview allow for any absolutes?',
  'Some people believe that we are the product of a random evolutionary process. Do you think discussions about right and wrong have a place in that kind of worldview?',
  'How do/will you teach your kids right from wrong?',
  'What authority do you appeal to?',
  'What experiences have shaped your worldview the most?',
  'Has there been one book or movie that\'s left its mark on you in a significant way? How so?',
  'Besides your parents, is there any one person who stands out as having had a major role in shaping your life? Tell me about him or her.',
  'If you could ask God three questions, what would you ask?',
  'If God were to ask this one question, "Are you for me or against me?" what would you say?',
  'If Jesus were here right now, what would you ask him?',
];
